export const URL_API = process.env.REACT_APP_API_URL || 'http://localhost:10001';
export const URL_WS = process.env.REACT_APP_WS_URL || 'http://localhost:10004';
// Kênh WS xe bus (/ws/bus) nằm ở HOST KHÁC với kênh chat (/ws/chat).
// Trên prod nginx của `testad` chỉ proxy /ws/chat — gọi /ws/bus ở đó trả 404 nên trang
// "Theo dõi xe bus" luôn hiện "Chưa kết nối". Host phục vụ /ws/bus là `api.timesschools.edu.vn`
// (đã verify: /ws/bus/info → 200 SockJS, handshake → 101, CORS cho origin quanly).
// Ngược lại `api` lại chặn /ws/chat (401) ⇒ BẮT BUỘC tách 2 biến, không gộp làm một.
export const URL_WS_BUS = process.env.REACT_APP_WS_BUS_URL || URL_WS;
// POS Bridge chạy cục bộ trên PC kế toán (loopback, cổng cố định). Override qua env khi cần.
export const URL_POS_BRIDGE = process.env.REACT_APP_POS_BRIDGE_URL || 'http://127.0.0.1:8790';
